<template>
  <div>
    <div class="flex gap-x-0.5">
      <label v-for="n in length" :key="n" class="inline-flex cursor-pointer">
        <input
          v-model="internalValue"
          :name="name"
          type="radio"
          :value="n"
          :disabled="disabled"
          class="sr-only"
        />
        <UiIcon
          :name="n <= Number(internalValue) ? 'star_filled' : 'star_outlined'"
          class="h-6 w-6 text-button-primary"
        />
      </label>
    </div>
    <FieldHint
      v-if="!hideDetails"
      :error="Boolean(errorMessage)"
      :message="errorMessage || hint || ''"
    />
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";
import FieldHint from "~/components/shared/FieldHint.vue";

const props = withDefaults(
  defineProps<{
    modelValue: boolean | string | number | null | Array<any>;
    name: string;
    disabled?: boolean;
    hideDetails?: boolean;
    hint?: string;
    length?: number;
  }>(),
  { hint: "", length: 5 },
);

const emit = defineEmits(["update:modelValue"]);

const { errorMessage, handleChange } = useField(props.name, undefined, {
  initialValue: props.modelValue,
});

const internalValue = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    if (props.name) {
      // handleChange(props.modelValue);
      handleChange(newValue);
    }
    emit("update:modelValue", newValue);
  },
});
</script>
